import Vue from 'vue'
import axios from 'axios'
import { VueAxios } from './axios'
import { ACCESS_TOKEN } from './globalConst'
import { Modal } from 'ant-design-vue';
Vue.use(Modal)
import '@/permission'
// 创建 axios 实例
const service = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL, // '/api', // api base_url
    timeout: 30000 // 请求超时时间
})

const err = error => {
    if (error.response) {
        console.log('请求异常', error);
        if (error.response.status == 401) {
            //登录超时
            Vue.ls.remove(ACCESS_TOKEN)
            Vue.ls.remove('X-Access-Token')
            Modal.error({
                title: '提示：',
                content: '登录超时，请重新登录',
                keyboard: false,
                okText: '重新登录',
                onOk: () => {
                    window.location = '/login'
                }
            })

        } else {
            if (error.response.data.type != "text/plain") {
                Modal.error({
                    title: '错误',
                    content: error.response.data
                })
            }

        }
    }
    return Promise.reject(error)
}


// request interceptor
service.interceptors.request.use(config => {
    const token = Vue.ls.get(ACCESS_TOKEN)
    const refreshToken = Vue.ls.get('X-Access-Token')
    if (token) {
        config.headers['Authorization'] = 'Bearer ' + token
    }
    if (refreshToken) {
        config.headers['X-Authorization'] = 'Bearer ' + refreshToken
    }
    return config
}, err)

/**
 * response interceptor
 * 所有请求统一返回
 */
service.interceptors.response.use(response => {
    // LocalStorage 存储的 token 和 refreshToken，不设定过期时间，由服务端统一处理
    if (response.headers['access-token']) {
        Vue.ls.set(ACCESS_TOKEN, response.headers['access-token'] /*, 7 * 24 * 60 * 60 * 1000 */ )
    }
    if (response.headers['x-access-token']) {
        Vue.ls.set('X-Access-Token', response.headers['x-access-token'] /*, 7 * 24 * 60 * 60 * 1000 */ )
    }
    if (response.request.responseType === 'blob') {
        return response
    }
    const resData = response.data
    const code = response.data.code

    if (code === 401 /* || code === 1011006 || code === 1011007 || code === 1011008 || code === 1011009 */ ) {
        // Modal.error({
        //     title: '提示：',
        //     content: resData.message,
        //     keyboard: false,
        //     okText: '重新登录',
        //     onOk: () => {

        //         window.location.reload()
        //     }
        // })

        // 授权过期，清理本地缓存的记录，不论 Modal.error 的 onOk 是否确认，先清理
        // 否则会在没按 OK 时，刷新网页或者重新访问，都会弹出“未授权的提示框”
        // 这样的调整后，TOKEN 为空直接重定向，SetHasError 的设置和判断其实已经用不上
        Vue.ls.remove(ACCESS_TOKEN)
        Vue.ls.remove('X-Access-Token')
        window.location.reload()
    } else if (code == 500) {

        Modal.error({
            title: '提示：',
            content: resData.message,
            keyboard: false,
        })

    }

    return resData
}, err)

const installer = {
    vm: {},
    install(Vue) {
        Vue.use(VueAxios, service)
    }
}

export { installer as VueAxios, service as axios }